export { HasPhoneNumber } from './has-phone-number';
